<ng-template #selecticons let-qrcode="qrcode">
    <ion-icon [uppDataid]="'tablethumb-thumb-check-' + qrcode['number'] + '-button'"
        [name]="(checked) ? 'checkmark-circle-outline' : 'radio-button-off-outline'"
        class="floating top right check"
        [ngClass]="{ checked: checked }"
        (click)="OnCheck()"
    ></ion-icon>
</ng-template>

<upp-visible-control mode="content">
    <ng-container *ngIf="qrcode !== null">
        <div class="qrcode" [ngClass]="{ disabled: disabled }">
            <upp-thumb *ngIf="qrcode.status === 'PA'" uppTouch [uppDataid]="'tablethumb-' + qrcode.number + '-thumb'"
                [wait]="true"
                [foot]="tr('@place_table_number', [ qrcode.number ])"
                [color]="qrcode.thumb.color"
                [title]="tr('@place_table_status_' + qrcode.Status)"
                (TouchClick)="OnSelect()"
            ></upp-thumb>
            <upp-thumb *ngIf="qrcode.status !== 'PA'" uppTouch [uppDataid]="'tablethumb-' + qrcode.number + '-thumb'"
                [icon]="qrcode.thumb.icon"
                [foot]="tr('@place_table_number', [ qrcode.number ])"
                [color]="qrcode.thumb.color"
                [title]="tr('@place_table_status_' + qrcode.Status)"
                (TouchClick)="OnSelect()"
            ></upp-thumb>

            <ion-icon *ngIf="(qrcode.status !== 'PA') && qrcode.IsConnected && (target !== 'SELECT')"
                [uppDataid]="'tablethumb-' + qrcode.number + '-online-icon'"
                class="online"
                [color]="qrcode.thumb.color"
                name="qr-code-outline"
            ></ion-icon>

            <ng-container *ngIf="qrcode.diners > 0">
                <ion-chip class="cart" [ngClass]="(qrcode.IsConnected && (target !== 'SELECT')) ? 'left' : 'right'" [uppDataid]="'tablethumb-' + qrcode.number + '-diners-chip'">
                    <ion-label>
                        <ion-icon name="people-outline"></ion-icon><span>{{ qrcode.diners }}</span>
                    </ion-label>
                </ion-chip>
            </ng-container>

            <!-- TARGET SELECT SPECIFIC ACTION -->
            <ng-container *ngIf="target === 'SELECT'">
                <ng-container [ngTemplateOutlet]="selecticons" [ngTemplateOutletContext]="{ qrcode: qrcode }"></ng-container>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="(target === 'TABLENO') || (qrcode === null)">
        <upp-thumb uppDataid="tablethumb-bynumber-button"
            icon="keypad-outline"
            color="dark"
            title="{{tr('@place_table_search_by_code')}}"
            detail="{{tr('@place_table_search_by_code_detail')}}"
        ></upp-thumb>
    </ng-container>
</upp-visible-control>
